import Image from 'next/image'
import styles from './styles/intro.module.css'

const IntroImage = ({ img, alt }) => (
    <div className={styles.headerImgs}>
      <Image className={styles.headerIndividualImg} width={1000} height={1000} alt={alt} src={img} />
    </div>
  )
export default IntroImage
